import React from 'react'
import PropTypes from 'prop-types'
import classes from './index.module.css'
import Step from './Step'

export default function EditOrganizationPopupFormStep({  setData, data }) {


  return (
    <div className={classes.wrapper}>
      <Step setData={setData} data={data} />
    </div>
  )
}

EditOrganizationPopupFormStep.propTypes = {
  setData: PropTypes.func,
  data: PropTypes.any,
}
